const data = [
  {
    heading: "Realiable",
    description: "Boost your brand recognition with each click",
    image: "images/reliable.svg",
  },
  {
    heading: "Scalable",
    description: " Gain insights into who is clicking your links.",
    image: "images/safe.svg",
  },
  {
    heading: "Secure",
    description: " Improve brand awareness and content discoverability.",
    image: "images/secure.svg",
  },
  {
    heading: "Fast",
    description: " Improve brand awareness and content discoverability.",
    image: "images/fast.svg",
  },
  {
    heading: "More Design",
    description: " Improve brand awareness and content discoverability.",
    image: "images/scalable.svg",
  },
  {
    heading: "High Resolution",
    description: " Improve brand awareness and content discoverability.",
    image: "images/resolution.svg",
  },
];

export default data;
